export const endpoint = "https://comedkku.net/nosql/api4all.php?";
